import tokenHttpClient from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

const appointmentListingService = async (baseURL, requestBody) => {
  try {
    const appointmentListingRequestObj = {
      page: requestBody?.page,
      size: requestBody?.size,
    };
    const appointmentListingResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.appointmentListing}`,
      JSON.stringify(appointmentListingRequestObj)
    );

    if (
      appointmentListingResponse?.status === 200 &&
      appointmentListingResponse.data
    ) {
      return appointmentListingResponse.data;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export default appointmentListingService;
